import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: 10px 12px;
  border: 1px solid ${colors.borderGrey};
  border-radius: 8px;
  background: ${colors.white};
  color: ${colors.fontPrimary};
  cursor: pointer;
  outline: none;
  min-width: 100px;
  text-align: left;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
  }

  &[data-open='true'] {
    border-color: ${colors.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TriggerText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Placeholder = styled.span`
  color: ${colors.grey};
`;

export const Chevron = styled.span<{ $open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s ease;
  transform: ${(p) => (p.$open ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${colors.fontSecondary};
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 200;
  margin: 0;
  padding: ${space[1]} 0;
  list-style: none;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 200px;
  overflow-y: auto;
`;

export const Option = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: 8px 12px;
  cursor: pointer;
  color: ${colors.fontPrimary};
  transition: background 0.1s ease;

  &:hover,
  &[data-active='true'] {
    background: ${colors.lighterGrey};
  }

  &[data-selected='true'] {
    font-weight: ${fonts.weight.semiBold};
  }

  &[data-disabled='true'] {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
